import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { bootNumFont } from "@/lib/numFont";
import { bootBrand } from "@/lib/theme";
bootNumFont();
bootBrand();
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import TxPage from "@/pages/TxPage";
import BankAccounts from "@/pages/BankAccounts";
import CariAccounts from "@/pages/CariAccounts";
import UpcomingPayments from "@/pages/UpcomingPayments";
import Products from "@/pages/Products";
import Proforma from "@/pages/Proforma";
import Reports from "@/pages/Reports";
import Recurring from "@/pages/Recurring";
import Cheques from "@/pages/Cheques";
import Loans from "@/pages/Loans";
import Agenda from "@/pages/Agenda";
import Kasa from "@/pages/Kasa";
import Settings from "@/pages/Settings";
import Activity from "@/pages/Activity";
import EmailSignature from "@/pages/EmailSignature";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ForcePasswordModal from "@/components/ForcePasswordModal";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-slate-500">Yükleniyor...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePasswordModal />;
  return (
    <Layout>
      <ForcePasswordModal />
      {children}
    </Layout>
  );
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
      <Route path="/sifre-sifirla" element={<ResetPassword />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/gelirler" element={<Protected><TxPage type="income" /></Protected>} />
      <Route path="/giderler" element={<Protected><TxPage type="expense" /></Protected>} />
      <Route path="/banka" element={<Protected><BankAccounts /></Protected>} />
      <Route path="/cari" element={<Protected><CariAccounts /></Protected>} />
      <Route path="/cek" element={<Protected><Cheques /></Protected>} />
      <Route path="/kredi" element={<Protected><Loans /></Protected>} />
      <Route path="/ajanda" element={<Protected><Agenda /></Protected>} />
      <Route path="/kasa" element={<Protected><Kasa /></Protected>} />
      <Route path="/odemeler" element={<Protected><UpcomingPayments /></Protected>} />
      <Route path="/tekrarlayan" element={<Protected><Recurring /></Protected>} />
      <Route path="/urunler" element={<Protected><Products /></Protected>} />
      <Route path="/proforma" element={<Protected><Proforma /></Protected>} />
      <Route path="/raporlar" element={<Protected><Reports /></Protected>} />
      <Route path="/aktivite" element={<Protected><Activity /></Protected>} />
      <Route path="/mail-imzasi" element={<Protected><EmailSignature /></Protected>} />
      <Route path="/ayarlar" element={<Protected><Settings /></Protected>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <CurrencyProvider>
            <Toaster position="top-right" richColors />
            <AppRoutes />
          </CurrencyProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
